export default class ReturnGoodsActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static SUCCESS_DATA='SUCCESS_DATA';
    static CANCEL_DATA = 'CANCEL_DATA';
    static GET_HELPER_RETURN_GOODS_FULL='GET_HELPER_RETURN_GOODS_FULL';
    static ERROR_SERVER='ERROR_SERVER';
    static RESET_LIST='RESET_LIST';
    static PRINT_RETURN_GOODS='PRINT_RETURN_GOODS';
    static BEFORE_PRINT_RETURN_GOODS='BEFORE_PRINT_RETURN_GOODS';
    static APPROVE='APPROVE';
    static REJECT='REJECT';
    static RETURN_DATA='RETURN_DATA';
    static VIEW_ITEM_DATA='VIEW_ITEM_DATA';
    static DATA_GOODS = 'DATA_GOODS';
  

    static approve() {
      return {
        type: ReturnGoodsActions.APPROVE
      };
    }
    static reject() {
      return {
        type: ReturnGoodsActions.REJECT
      };
    }
    
    static submit(){
      return {
        type: ReturnGoodsActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: ReturnGoodsActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: ReturnGoodsActions.UPDATE_DATA,
        payload: data
      };
    }

    static dataGoods(dataGoods) {
      return {
        type: ReturnGoodsActions.DATA_GOODS,
        payload: dataGoods
      };
    }

    static return(data) {
      return {
        type: ReturnGoodsActions.RETURN_DATA,
        payload: data
      };
    }

    static viewItem(data) {
      return {
        type: ReturnGoodsActions.VIEW_ITEM_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: ReturnGoodsActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: ReturnGoodsActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: ReturnGoodsActions.SHOW_DATA,
        payload: data
      };
    }
    static error(error){
      return {
        type: ReturnGoodsActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: ReturnGoodsActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: ReturnGoodsActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: ReturnGoodsActions.RESET_DATA,
      };
    }

    static helperFull(data){
        return {
          type: ReturnGoodsActions.GET_HELPER_RETURN_GOODS_FULL,
          payload:data
        };
      }

      static cancel() {
        return {
          type: ReturnGoodsActions.CANCEL_DATA
        };
      }

      static resetList(){
        return {
          type: ReturnGoodsActions.RESET_LIST,
        };
      }

      static errorInternal(error){
        return {
          type: ReturnGoodsActions.ERROR_SERVER,
          payload: error
        };
      }

      static beforePrint(){
        return {
          type: ReturnGoodsActions.BEFORE_PRINT_RETURN_GOODS,
        };
      }
      static print(data){
        return {
          type: ReturnGoodsActions.PRINT_RETURN_GOODS,
          payload: data
        };
      }
  }